module.exports = __webpack_public_path__ + "img/senc.fa9a661.svg";